import IGPostIcon from 'assets/icons/mono/IGPostIcon';
import IGStoryIcon from 'assets/icons/mono/IGStoryIcon';
import ReelsIcon from 'assets/icons/ReelsIcon';
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store';
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import 'swiper/css';
import 'swiper/css/navigation';
import { Post } from 'types/influencer';
import { showInfluencerPostModal } from 'slices/ui/reducer';
import { CollaborationPost } from 'types/campaign/collaborations';
interface IGMediaApproval {
  mediaType: "REELS" | "STORY" | "FEED" | "ALL",
  milestoneStep: string | null
}
const IGMedia: React.FC<IGMediaApproval> = ({ mediaType, milestoneStep }) => {

  const { campaignId, influencerId, milestoneId } = useParams();

  const milestoneData = useSelector((state: RootState) => state.collaborationMilestones.collaborations[campaignId!]?.[influencerId!]?.[milestoneId!]?.data);

  const collaborationData = useSelector((state: RootState) => state.collaborations.campaigns[campaignId!]?.collaborations?.[influencerId!]);

  const collaboration = collaborationData?.collaboration ?? null;
  const posts = milestoneId ? (milestoneData?.posts?.filter((post) => post.social_post.type === mediaType) ?? []) : (collaboration?.posts ?? []);

   const dispatch: AppDispatch = useDispatch();

  const viewPost = (post: CollaborationPost) => {
    dispatch(showInfluencerPostModal({ postId: post.social_post.uuid, influencer: collaboration.influencer, status: post.status as "pending" | "approved" | "rejected" | "processing", milestoneStep }))
  }

  return (
    <div className=" position-relative">
      {
        posts.length > 0 &&
        <Swiper
          slidesPerView={'auto'}
          spaceBetween={18}
          navigation={true}
          modules={[Navigation]}
          freeMode={true}
          className="mySwiper">
          {
            posts.map((post, i) => {
              return (
                <SwiperSlide className="w-auto milestone-view-ig-media" key={i}>
                  <div onClick={() => viewPost(post)} className="position-relative h-100 post-thumbnail" style={{ backgroundImage: `url(${post.social_post.thumbnail_url})` }}>
                    {
                      post.status === 'approved' && <span className="post-status-badge approved"> <i className="bx bx-check"></i>Approved</span>
                    }
                    {
                      post.status === 'pending' && <span className="post-status-badge new">New</span>
                    }
                    {
                      post.status === 'rejected' && <span className="post-status-badge declined"> <i className="bx bx-x"></i>Declined</span>
                    }
                    {
                      post.social_post?.ig?.media_product_type === 'REELS' &&
                      <span className="media-type-icon">
                        <ReelsIcon color="#FFFFFF" />
                      </span>
                    }
                    {
                      post.social_post?.ig?.media_product_type === 'STORY' &&
                      <span className="media-type-icon">
                        <IGStoryIcon />
                      </span>
                    }
                    {
                      !["REELS", "STORY"].includes(post.social_post?.ig?.media_product_type!) &&
                      <span className="media-type-icon">
                        <IGPostIcon />
                      </span>
                    }
                  </div>
                </SwiperSlide>

              )
            })
          }
        </Swiper>
      }
      {
        (!Array.isArray(posts) || posts.length === 0) &&
        <div className="col-12 h-100 w-100 d-flex justify-content-center align-items-center">
          <span className="no-collaboration-posts-msg">Waiting for collaboration post</span>
        </div>
      }
      {/* <span className="total-posts-count z-1">Total Posts : <span className="fw-500">{posts.length}</span></span> */}
    </div>
  )
}

export default IGMedia